// Module
var code = " <div class=\"react-container react-zoom\"> <assignment-wizard/> </div> ";
// Exports
module.exports = code;